<template>
  <ListItem>
    <template #media>
      <div class="score-tile m-rounded-icon">
        {{ formatScore(visit.score) }}
      </div>
    </template>
    <BranchFragment
      class="m-mb-8"
      :branch="branchGetter(visit.branch)"
    />
    <div class="m-stack-horizontal">
      <p class="m-font-bold">{{ formatDate(visit.performedAt) }}</p>
      <p>{{ formatActivityCount(visit.activityCount) }}</p>
    </div>
  </ListItem>
</template>

<script setup>
import formatDate from '@/util/formatDate';
import formatScore from '@/util/formatScore';
import formatActivityCount from '@/util/formatActivityCount';

import ListItem from '@/components/ListItem.vue';
import BranchFragment from '@/components/BranchFragment.vue';

defineProps({
  visit: {
    type: Object,
    required: true,
  },
  branchGetter: {
    typer: Function,
    required: true,
  },
});
</script>

<style scoped>
.score-tile {
  background-color: var(--gray-100);
  font-size: var(--font-size-100);
  font-weight: 700;
}
</style>
